import React from 'react'
import { Button, Wrap, WrapItem } from '@chakra-ui/react'
import { IncidentOption } from '../utils/incidentOptions'

interface TagCloudProps {
  options: IncidentOption[]
  selected: string[]
  onChange: (values: string[]) => void
  readOnly?: boolean
}

const TagCloud: React.FC<TagCloudProps> = ({
  options,
  selected,
  onChange,
  readOnly = false,
}) => {
  if (options.length === 0) return null

  const handleToggle = (value: string) => {
    if (readOnly) return
    const next = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value]
    onChange(next)
  }

  return (
    <Wrap spacing={2}>
      {options.map((opt) => {
        const isSelected = selected.includes(opt.value)
        return (
          <WrapItem key={opt.value}>
            <Button
              size='sm'
              variant={isSelected ? 'solid' : 'outline'}
              colorScheme='purple'
              onClick={() => handleToggle(opt.value)}
              isDisabled={readOnly}
              data-selected={isSelected ? true : undefined}
            >
              {opt.label}
            </Button>
          </WrapItem>
        )
      })}
    </Wrap>
  )
}

export default TagCloud
